export { ColorPicker } from './component';
export type { ColorPickerProps } from './types';
